import React, { useEffect, useState } from "react"
import likeBoard from "../../assets/images/likeBoard.png"
// TODO
import "./EventLikeBoard.css"
import EventButton from "../EventButton"
import Indicator from "../Indicator"
import { formatNumberWithCommas } from "../../utils/numberUtils"
import translations from "../../utils/translations"

function EventHeaderLikeBoard({
    profile,
    setIsLoginModalVisible,
    showToast,
    setIsAfterRegistedVisible,
    setIsNoTargetModalVisible,
    setAppsflyerTrackingCode,
    setIsApplyModalVisible,
    setIsInnerModalVisible,
    setIsDone,
    isDone,
    setImageSrc,
    imageSrc,
}) {
    const [state, setState] = useState(false)
    //FIXME-REAL
    const [nickName, setNickName] = useState(profile?.nickname)
    const [likeGiven, setLikeGiven] = useState("***")
    const [likeTaken, setLikeTaken] = useState("***")
    const [point, setPoint] = useState("*******")
    //FIXME-TEST
    // const [nickName, setNickName] = useState("123456");
    // const [likeGiven, setLikeGiven] = useState("12345");
    // const [likeTaken, setLikeTaken] = useState("12345");
    // const [point, setPoint] = useState("1234567");

    const [userLikeGiven, setUserLikeGiven] = useState(profile?.likeGivenCount)
    const [userLikeTaken, setUserLikeTaken] = useState(profile?.likeTakenCount)
    const [userPoint, setUserPoint] = useState(profile?.point)
    const [userSendYn, setUserSendYn] = useState(profile?.sendYn)

    useEffect(() => {
        // FIXME : for Test
        // setIsLoading(false);
        if (profile) {
            setNickName(profile?.nickname)
            setUserLikeGiven(profile?.likeGivenCount)
            setUserLikeTaken(profile?.likeTakenCount)
            setUserPoint(profile?.point)
            setUserSendYn(profile?.sendYn)
        }
        if (state) {
            // TODO
            // 한국
            // setLikeGiven(formatNumberWithCommas(userLikeGiven) + "개");
            // setLikeTaken(formatNumberWithCommas(userLikeTaken) + "개");
            // 나머지
            // setLikeGiven(formatNumberWithCommas(userLikeGiven) + "");
            // setLikeTaken(formatNumberWithCommas(userLikeTaken) + "");
            setLikeGiven(formatNumberWithCommas(userLikeGiven) + "")
            setLikeTaken(formatNumberWithCommas(userLikeTaken) + "")
            if (userPoint < 0) {
                setPoint("0P")
            } else {
                setPoint(formatNumberWithCommas(userPoint) + "P")
            }
        }
    }, [state, userLikeGiven, userLikeTaken, userPoint, profile])

    function clickButton() {
        if (profile) {
            if (!state) {
                setState((prev) => !prev)
                setAppsflyerTrackingCode(translations.TRACKING_CODE.calculate, {
                    profile_id: profile.id,
                })
            }
        }
    }

    return (
        <div className="event-like-board">
            <img src={likeBoard} alt="Event Like Board" />
            <div className="nick-name">{nickName}</div>
            <div className="point1">{likeTaken}</div>
            <div className="point2">{likeGiven}</div>
            <div className="point-total">{point}</div>

            <EventButton
                profile={profile}
                onUpperClick={clickButton}
                upperState={state}
                setIsLoginModalVisible={setIsLoginModalVisible}
                showToast={showToast}
                setIsAfterRegistedVisible={setIsAfterRegistedVisible}
                setIsNoTargetModalVisible={setIsNoTargetModalVisible}
                setIsApplyModalVisible={setIsApplyModalVisible}
                setAppsflyerTrackingCode={setAppsflyerTrackingCode}
                setIsInnerModalVisible={setIsInnerModalVisible}
                setIsDone={setIsDone}
                isDone={isDone}
                setImageSrc={setImageSrc}
                imageSrc={imageSrc}
            />
        </div>
    )
}

export default EventHeaderLikeBoard
